import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Lock, ArrowLeft, Loader2 } from 'lucide-react';
import { maskPhone, onlyDigits } from './calcUtils';

export const LeadGate = ({ lead, setLead, loading, onBack, onSubmit }) => {
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!lead.name.trim()) {
      setError('Informe seu nome.');
      return;
    }
    if (onlyDigits(lead.phone).length < 10) {
      setError('Informe um telefone válido com DDD.');
      return;
    }
    setError('');
    onSubmit();
  };

  return (
    <div className="space-y-5" data-testid="calculator-lead-gate">
      <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 flex items-start gap-3">
        <Lock className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-semibold text-slate-900">Seu resultado está pronto!</p>
          <p className="text-sm text-slate-600">Preencha seus dados para visualizar a comparação completa entre os regimes.</p>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="lead-name">Nome completo *</Label>
        <Input
          id="lead-name"
          data-testid="calc-lead-name-input"
          placeholder="Dr(a). Seu nome"
          value={lead.name}
          onChange={(e) => setLead({ ...lead, name: e.target.value })}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="lead-phone">Telefone / WhatsApp *</Label>
        <Input
          id="lead-phone"
          data-testid="calc-lead-phone-input"
          inputMode="tel"
          placeholder="(95) 99999-9999"
          value={lead.phone}
          onChange={(e) => setLead({ ...lead, phone: maskPhone(e.target.value) })}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="lead-email">E-mail — receba o resultado completo (opcional)</Label>
        <Input
          id="lead-email"
          data-testid="calc-lead-email-input"
          type="email"
          placeholder="seu@email.com"
          value={lead.email}
          onChange={(e) => setLead({ ...lead, email: e.target.value })}
        />
      </div>

      {error && <p className="text-sm text-red-600" data-testid="calc-lead-error">{error}</p>}

      <div className="flex gap-3">
        <Button variant="outline" onClick={onBack} className="rounded-md" data-testid="calc-back-button">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Voltar
        </Button>
        <Button onClick={handleSubmit} disabled={loading} className="flex-1 btn-primary rounded-md py-6 text-base font-semibold" data-testid="calc-see-result-button">
          {loading ? <Loader2 className="mr-2 h-5 w-5 animate-spin" /> : null}
          {loading ? 'Calculando...' : 'Ver meu resultado'}
        </Button>
      </div>
      <p className="text-xs text-slate-500 text-center">
        Seus dados estão seguros e serão usados apenas para contato da equipe Apex.
      </p>
    </div>
  );
};
